/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Pnk_Items_RequiredInputs */

const vi_pl_pnk_items_required = /** @type {(inputs: Pl_Pnk_Items_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn ít nhất 1 lô chè mua và nhập khối lượng`)
};

/**

* @param {Pl_Pnk_Items_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_pnk_items_required = /** @type {((inputs?: Pl_Pnk_Items_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Pnk_Items_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_pnk_items_required(inputs)
});